import { render, staticRenderFns } from "./AppInformationHeader.vue?vue&type=template&id=3aa62078"
import script from "./AppInformationHeader.vue?vue&type=script&lang=js"
export * from "./AppInformationHeader.vue?vue&type=script&lang=js"
import style0 from "./AppInformationHeader.vue?vue&type=style&index=0&id=3aa62078&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports